function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Kaggle } from "../../../sdk";
var SuggestionType = Kaggle.Sdk.Datasets.SuggestionType;
export function sendKernelEvent(action, suffix) {
    var gaAction = suffix ? action + "-" + suffix : action;
    gtag("event", gaAction, {
        event_category: "kernel"
    });
}
export function sendDatasetEvent(action, suffix) {
    var gaAction = suffix ? action + "-" + suffix : action;
    gtag("event", gaAction, {
        event_category: "dataset"
    });
}
export function sendDatasetNewVersionEvent(label) {
    var tmpLabel = label || "";
    gtag("event", "dataset-new-version-created", {
        event_category: "dataset",
        event_label: tmpLabel
    });
}
export function sendUpvote(label, suffix) {
    var tmpLabel = label || "";
    var gaLabel = suffix ? tmpLabel + "-" + suffix : tmpLabel;
    sendVote("up-voted", gaLabel);
}
export function sendDownvote(label, suffix) {
    var tmpLabel = label || "";
    var gaLabel = suffix ? tmpLabel + "-" + suffix : tmpLabel;
    sendVote("down-voted", gaLabel);
}
function sendVote(voteType, label) {
    gtag("event", voteType, {
        event_category: "vote",
        event_label: label
    });
}
export function sendAccountEvent(action) {
    gtag("event", action, {
        event_category: "account"
    });
}
export function sendAvatarEvent(context) {
    gtag("event", "clicked", {
        event_category: "avatar",
        event_label: context
    });
}
export function clickedSuggestion(id, type) {
    var action = type + "-suggesion-clicked";
    gtag("event", action, {
        event_category: toEventCategory(type),
        event_label: id
    });
}
function toEventCategory(type) {
    switch(type){
        case SuggestionType.CATEGORY:
            return "category";
        case SuggestionType.COMPETITION:
            return "competition";
        case SuggestionType.DATASET:
            return "dataset";
        case SuggestionType.KERNEL:
            return "kernel";
    }
    return undefined;
}
/**
 * Sets custom dimension defined in Google Analytics dashboard. Current mapping:
 * dimension1: turbolinks - Whether Turbolinks is enabled (legacy dimension)
 */ export function setDimension(index, name) {
    gtag("set", {
        custom_map: _defineProperty({}, "dimension".concat(index), name)
    });
}
/**
 * Sets custom metric defined in Google Analytics dashboard. Current mapping:
 * metric1: timeToReactRender - Time between receiving HTML and React render
 */ export function setMetric(index, value) {
    gtag("set", {
        custom_map: _defineProperty({}, "metric".concat(index), value)
    });
}
export function registerPageview(track) {
    gtag("set", {
        page_path: track
    });
    gtag("event", "page_view");
}
